
export class ExtraFee {
  'id'?: number;
  'extra_fees_price': number;
  'extra_fees_condition': string;
  'extra_fees_name': string;
  'frequency_value': number;
  'frequency_name': string;
  'delete': boolean;
}
